import { rulebaseApi2Request } from "@/lib/rulebase-api2-client/client";
import { queryOptions } from "@tanstack/react-query";

export type CallTranscriptMessage = {
  speaker: "agent" | "customer" | "unknown";
  text: string;
  /** Offset from the start of the call, used for the transcript time gutter. */
  start_ms: number;
};

export type AgentCall = {
  id: string;
  started_at: string | null;
  ended_at: string | null;
  duration_ms: number | null;
  direction: string | null;
  customer_name: string | null;
  company_name: string | null;
  conversation: {
    id: string | null;
    external_id: string | null;
    external_url: string | null;
    subject: string | null;
  } | null;
  agent: { id: string | null; name: string | null } | null;
  summary: string | null;
  summary_generated_at: string | null;
  transcribed_at: string | null;
};

export type AgentCallDetail = AgentCall & {
  transcript: CallTranscriptMessage[];
};

/** The signed-in agent's recent calls, newest first. */
export function getRecentCallsQueryOptions(params?: {
  limit?: number;
}) {
  const search = new URLSearchParams();
  if (params?.limit != null) search.set("limit", String(params.limit));

  return queryOptions({
    queryKey: ["calls", "recent", params?.limit],
    queryFn: () =>
      rulebaseApi2Request<{ data: AgentCall[] }>(
        `/calls${search.size > 0 ? `?${search.toString()}` : ""}`,
      ),
  });
}

export function getAgentCallQueryOptions(callId: string) {
  return queryOptions({
    queryKey: ["calls", callId],
    queryFn: () =>
      rulebaseApi2Request<{ data: AgentCallDetail }>(`/calls/${callId}`),
  });
}
